import { Api } from "./api"

export class ApproveSampleApi extends Api {
  constructor() {
    super('can_approve_sample_permissions', ['canApproveSample'])
  }
}
